var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcVodOn = function SvgIcVodOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_vod_on_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.833 0H15.167C6.79 0 0 6.79 0 15.167v21.666C0 45.21 6.79 52 15.167 52h21.666C45.21 52 52 45.21 52 36.833V15.167C52 6.79 45.21 0 36.833 0Z",
    fill: "#E9F5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.003 41.166c8.376 0 15.166-6.79 15.166-15.166 0-8.377-6.79-15.167-15.166-15.167-8.377 0-15.167 6.79-15.167 15.167 0 8.376 6.79 15.166 15.167 15.166Z",
    fill: "#6ACDF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.654 25.111-8.471-4.896a1.028 1.028 0 0 0-1.538.888v9.793c0 .78.845 1.279 1.538.889l8.471-4.897a1.019 1.019 0 0 0 0-1.777Z",
    fill: "#E9F5FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_vod_on_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h52v52H0z"
  })))));
};
export default SvgIcVodOn;